import { defineComponent } from 'vue';
import translator from '~/zf/frontend/common/mixins/translator';
import AlarmType from '../../../../../portlet/viiu/alarms/const/AlarmType';
export default defineComponent({
    name: 'AlarmSelected',
    compatConfig: {
        MODE: 3,
    },
    mixins: [translator],
    props: {
        alarmType: {
            type: String,
            required: true,
        },
        alarmId: {
            type: Number,
            required: true,
        },
        alarmTypeId: {
            type: Number,
            required: true,
        },
    },
    computed: {
        description() {
            const wrenchIcon = this.alarmTypeId === AlarmType.USER_DEFINED
                ? '<span class="icomoon icon-wrench-circle mr-2"></span>'
                : '';
            return `${wrenchIcon}${this.alarmType} ・ <span class="font-weight-bold">ID</span> ${this.alarmId}`;
        },
    },
});
